import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductDetailComponent } from '../product/productdetail/product.detail.component';
import { CatalogueListV2Component } from './catalogue-list-v2/catalogue-list-v2.component';
import { CatalogueEditV2Component } from './catalogue-edit-v2/catalogue-edit-v2.component';
import { CatalogueSubscriptionsV2Component } from './catalogue-subscriptions-v2/catalogue-subscriptions-v2.component';
import { CanActivateCateloguesV2 } from './catalogues-v2.guard';
import { NewsletterDetailV2Component } from './newsletter-detail-v2/newsletter-detail-v2.component';
import { NewsletterEditV2Component } from './newsletter-edit-v2/newsletter-edit-v2.component';

const routes: Routes = [
  {
    path: 'catalogues',
    component: CatalogueListV2Component,
    data: {
      breadcrumb: 'Catalogues',
    },
    children: [
      {
        path: 'newsletter/:sku/:vendorName',
        component: NewsletterDetailV2Component,
        data: {
          breadcrumb: 'vendorName',
        },
        children: [{
          path: 'product/:sku',
          component: ProductDetailComponent,
          data: {
            breadcrumb: 'sku'
          },
          children: [
            {
              path: 'bundledproduct/:sku',
              component: ProductDetailComponent,
              data: {
                  breadcrumb: 'sku',
              }
          }]
        }]
      },
      {
        path: 'subscriptions',
        component: CatalogueSubscriptionsV2Component,
        data: {
          breadcrumb: 'Subscriptions'
        }
      }
    ]
  },
  {
    path: 'catalogueedit',
    component: CatalogueEditV2Component,
    canActivate:[CanActivateCateloguesV2],
    data: {
      breadcrumb: 'Catalogue Edit',
    },
    children: [
      {
        path: 'editnewsletter/:sku',
        component: NewsletterEditV2Component,
        data: {
          breadcrumb: 'Edit Newsletter'
        }
      },
      {
        path: 'newsletter/:sku',
        component: NewsletterDetailV2Component
      },
      {
        path: 'subscriptions',
        component: CatalogueSubscriptionsV2Component,
        data: {
          breadcrumb: 'Subscriptions'
        }
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CataloguesV2RoutingModule { }
